import { Controller } from "@hotwired/stimulus"

// 新規登録フォームの規約同意チェック (#2716)。
// 初期 disabled は HTML ではなく connect() で付与する。JS が動かない環境で
// 登録ボタンが永久に押せなくなるのを避けるため (プログレッシブエンハンスメント)。
export default class extends Controller {
  static targets = ["agree", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.submitTarget.disabled = !this.agreeTarget.checked
  }
}
